module.exports = __webpack_public_path__ + "static/media/logo.8bda41a6.png";